export const regexSet = {
  Number_Regex: /^[0-9]*$/,
  SpecialChar_Regex: /^[\w&#_ -]+$/,
  Phone_Regex: /^(0|91)?[6-9][0-9]{9}$/,
  Email_Regex:
    /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};

export default { regexSet };
